export default "__VITE_ASSET__C86u2XdY__"